/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IUser } from 'app/shared/model/user.model';
import { IContactDetails } from 'app/shared/model/contact-details.model';
import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { LabServiceType } from 'app/shared/model/enumerations/lab-service-type.model';

export interface IDiaglabAssistant {
  id?: string;
  name?: string;
  email?: string;
  age?: number | null;
  gender?: string | null;
  mobile?: string;
  dateOfBirth?: number;
  bloodGroup?: string;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  cursor?: number;
  active?: boolean;
  education?: string | null;
  training?: string | null;
  experience?: string | null;
  achievements?: string | null;
  labServiceType?: keyof typeof LabServiceType | null;
  tmUser?: IUser;
  contactCode?: IContactDetails | null;
  diagLab?: IDiagLab;
}

export const defaultValue: Readonly<IDiaglabAssistant> = {
  active: false,
};
